<template>
  <nav class="blog-navigation">
    <ul class="blog-navigation__list">
      <li class="blog-navigation__item">
        <MyLink class="blog-navigation__item-link" :name="RouteNames.BLOG_HOME">
          <img
            v-if="!isRouteMatched(RouteNames.BLOG_HOME)"
            src="~/assets/icons/home-dark.svg"
            alt="blog main"
          />
          <img v-else src="~/assets/icons/home-light.svg" alt="blog main" />
        </MyLink>
      </li>
      <li
        v-for="navigationItem in blogStore.categories"
        class="blog-navigation__item"
      >
        <MyLink
          class="blog-navigation__item-link"
          :name="RouteNames.BLOG_CATEGORY"
          :params="{
            categorySlug: navigationItem.slug,
          }"
        >
          {{ navigationItem.name }}
        </MyLink>
      </li>
    </ul>
  </nav>
</template>

<script setup>
import { isRouteMatched } from "~/utils/valueMatched";
import { useBlogStore } from "~/nuxt_modules/blog/store/blog.store.js";
import { RouteNames } from "~/nuxt_modules/common/config/route.config.js";

const blogStore = useBlogStore();
</script>

<style scoped lang="scss">
.blog-navigation {
  background-color: var(--color-blue-100);
  border-radius: 30px;

  padding: 4px;
  &__list {
    @include flex-container(row, flex-start, center);
    flex-wrap: nowrap;
    gap: 8px;

    overflow-y: auto;
  }

  &__item {
    display: flex;
  }

  &__item-link {
    min-width: 166px;
    width: max-content;

    @include flex-container(row, center, center);

    @include font(18, 26, 500);
    text-align: center;

    background-color: transparent;
    border-radius: 30px;

    padding: 8px;

    transition: background-color 0.2s;

    &:not(.router-link-exact-active) {
      @include on-hover {
        background-color: rgba(255, 255, 255, 0.6);
      }
    }

    &.router-link-exact-active {
      background-color: var(--color-primary-base);
      color: white;
    }

    @include mobile {
      min-width: 122px;
    }
  }
}
</style>
